import React, { createContext, useContext, useState } from "react";

const translations = {
  en: {
    chat: "Chat",
    results: "Results",
    assistant: "Assistant",
    placeholder: "Ask a question about race results…",
    ask: "Ask",
    error: "Error",
    thinking: "thinking…",
    progressGenerating: "Generating SQL query…",
    progressRunning: "Running query against the database…",
    progressAnalyzing: "Analyzing results…",
    progressFinalizing: "Preparing response…",
    hideSQL: "▾ hide SQL",
    showSQL: "▸ show SQL",
    welcomeNoStats:
      'Ask me anything about NYRR race data. For example: "Show me head to head stats between John Smith and Jane Doe" or "What was the winning time at the 2023 NYC Marathon?"',
    welcomeStats: (races, results) =>
      `Ask me anything about NYRR race data. The database currently contains ${races} races and ${results} results. Try: "Show me head to head stats between John Smith and Jane Doe" or "What was the winning time at the 2023 NYC Marathon?"`,
    resultsEmpty: "Results will appear here once you ask a question.",
    noData: "No data found for that query.",
    row: "row",
    rows: "rows",
    allRunners: "← All runners",
    runners: "runners",
    colHash: "#",
    colName: "Name",
    colLocation: "Location",
    colAge: "Age",
    colGender: "Gender",
    colRaces: "Races",
    ageMobile: "age",
    teamNotFound: "Team not found.",
    loading: "Loading…",
  },
  es: {
    chat: "Chat",
    results: "Resultados",
    assistant: "Asistente",
    placeholder: "Haz una pregunta sobre resultados de carreras…",
    ask: "Preguntar",
    error: "Error",
    thinking: "pensando…",
    progressGenerating: "Generando consulta SQL…",
    progressRunning: "Ejecutando consulta en la base de datos…",
    progressAnalyzing: "Analizando resultados…",
    progressFinalizing: "Preparando respuesta…",
    hideSQL: "▾ ocultar SQL",
    showSQL: "▸ mostrar SQL",
    welcomeNoStats:
      'Pregúntame cualquier cosa sobre los datos de carreras de NYRR. Por ejemplo: "Muéstrame las estadísticas entre John Smith y Jane Doe" o "¿Cuál fue el tiempo ganador en el Maratón de NYC 2023?"',
    welcomeStats: (races, results) =>
      `Pregúntame cualquier cosa sobre los datos de carreras de NYRR. La base de datos contiene actualmente ${races} carreras y ${results} resultados. Prueba: "Muéstrame las estadísticas entre John Smith y Jane Doe" o "¿Cuál fue el tiempo ganador en el Maratón de NYC 2023?"`,
    resultsEmpty: "Los resultados aparecerán aquí cuando hagas una pregunta.",
    noData: "No se encontraron datos para esa consulta.",
    row: "fila",
    rows: "filas",
    allRunners: "← Todos los corredores",
    runners: "corredores",
    colHash: "#",
    colName: "Nombre",
    colLocation: "Ubicación",
    colAge: "Edad",
    colGender: "Género",
    colRaces: "Carreras",
    ageMobile: "edad",
    teamNotFound: "Equipo no encontrado.",
    loading: "Cargando…",
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const toggleLang = () => setLang((l) => (l === "en" ? "es" : "en"));
  return (
    <LanguageContext.Provider value={{ lang, t: translations[lang], toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  return useContext(LanguageContext);
}
